import { useEffect } from "react";
import { Phone } from "lucide-react";
import { useDemo } from "@/store/DemoStore";
import { CURRENT_CLIENT_ID } from "@/data/constants";
import { Avatar, avatarUrl, demoToast } from "@/components/common";
import { ChatThread } from "@/components/ChatThread";

export default function ClientMessages() {
  const { convFor, send, markRead, settings, trips } = useDemo();
  const conv = convFor(CURRENT_CLIENT_ID);
  const len = conv?.messages.length;
  useEffect(() => { if (conv?.unreadClient) markRead(conv.id, "client"); }, [conv?.id, len]); // eslint-disable-line react-hooks/exhaustive-deps
  const tripId = conv?.tripId || trips.find((t) => t.clientId === CURRENT_CLIENT_ID)?.id;

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden bg-white md:rounded-2xl md:border md:border-slate-200" data-testid="client-messages">
      <div className="flex shrink-0 items-center gap-3 border-b border-slate-200 px-4 py-3">
        <Avatar name={settings.advisorName} src={avatarUrl(settings.advisorId, settings.advisorAvatar)} />
        <div className="min-w-0 flex-1">
          <p className="truncate font-semibold text-navy-900" data-testid="client-chat-advisor-name">{settings.advisorName}</p>
          <p className="flex items-center gap-1.5 text-xs text-slate-500"><span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />Your advisor · usually replies within an hour</p>
        </div>
        <button onClick={() => demoToast("Calling")} data-testid="client-chat-call-btn" aria-label="Call advisor" className="grid h-10 w-10 place-items-center rounded-full text-navy-700 hover:bg-slate-100"><Phone className="h-5 w-5" /></button>
      </div>
      <ChatThread
        className="min-h-0 flex-1"
        messages={conv?.messages || []}
        viewer="client"
        onSend={(text) => send(CURRENT_CLIENT_ID, "client", text, tripId)}
        placeholder="Message your advisor…"
        suggestions={["When is my final payment due?", "Can you add an excursion?", "Thank you!"]}
      />
    </div>
  );
}
